<template>
  <div class="receive-list">
    <div class="mail-send">
      <el-select class="mail-input" placeholder="发送对象" v-model="target">
        <el-option value="1" label="个人"></el-option>
        <el-option value="0" label="发送文件用户"></el-option>
        <el-option value="-999" label="整个公司"></el-option>
      </el-select>
      <el-input v-show="target == '1'" placeholder="工号" v-model="gongid" class="mail-input" clearable></el-input>
      <el-input placeholder="邮件标题" type="email" v-model="mailTitle" class="mail-input" clearable></el-input>
      <el-input placeholder="发件人邮箱" type="email" v-model="senderMail" class="mail-input" clearable></el-input>
      <el-input placeholder="发件人邮箱密码" type="password" v-model="senderPwd" class="mail-input" clearable></el-input>
      <el-button @click="send">测试发送</el-button>
    </div>
    <div class="mail-send">
      <el-button-group>
        <el-button :type="activeBtn === '' ? 'primary' : 'default'" @click="sort('')">全部</el-button>
        <el-button :type="activeBtn === 'sf' ? 'primary' : 'default'" @click="sort('sf')">发送失败</el-button>
        <el-button :type="activeBtn === 'on' ? 'primary' : 'default'" @click="sort('on')">未打开</el-button>
        <el-button :type="activeBtn === 'cn' ? 'primary' : 'default'" @click="sort('cn')">未点击</el-button>
      </el-button-group>
    </div>
    <c-table ref="table" @before-fetch="beforeFetch" :columns="columns" url="/emailj/result" :defaultParam="{id: fetchId}">
      <el-table-column slot="gongid" show-overflow-tooltip label="工号">
        <template v-slot="{row}">
          <span>{{row.gongid}}</span>
        </template>
      </el-table-column>
      <el-table-column slot="name" show-overflow-tooltip label="姓名">
        <template v-slot="{row}">
          <span>{{row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column slot="email" show-overflow-tooltip label="邮箱">
        <template v-slot="{row}">
          <span>{{row.email}}</span>
        </template>
      </el-table-column>
      <el-table-column slot="email" show-overflow-tooltip label="发送时间">
        <template v-slot="{row}">
          <span>{{row.sendtime}}</span>
        </template>
      </el-table-column>
      <el-table-column slot="email" show-overflow-tooltip label="发送状态">
        <template v-slot="{row}">
          <span>{{row.sendstatus}}</span>
        </template>
      </el-table-column>
      <el-table-column slot="email" show-overflow-tooltip label="打开时间">
        <template v-slot="{row}">
          <span>{{row.opentime}}</span>
        </template>
      </el-table-column>
      <el-table-column slot="email" show-overflow-tooltip label="打开次数">
        <template v-slot="{row}">
          <span>{{row.opentimes}}</span>
        </template>
      </el-table-column>
      <el-table-column slot="email" show-overflow-tooltip label="点击时间">
        <template v-slot="{row}">
          <span>{{row.clicktime}}</span>
        </template>
      </el-table-column>
      <el-table-column slot="email" show-overflow-tooltip label="点击次数">
        <template v-slot="{row}">
          <span>{{row.clicktimes}}</span>
        </template>
      </el-table-column>
    </c-table>
  </div>
</template>
<script>
import CTable from '@/components/common/table'
import mixin from '@/mixins'
import qs from 'qs'

export default {
  mixins: [ mixin ],
  components: { CTable },
  data () {
    return {
      columns: [
        { slot: 'gongid' },
        { slot: 'name' },
        { slot: 'email' },
        { slot: 'sendtime' },
        { slot: 'sendstatus' },
        { slot: 'opentime' },
        { slot: 'opentimes' },
        { slot: 'clicktime' },
        { slot: 'clicktimes' }
      ],
      fetchId: null,
      gongid: '',
      mailTitle: '',
      senderMail: '',
      senderPwd: '',
      activeBtn: '',
      target: '1'
    }
  },
  created () {
    const search = qs.parse(location.search, { ignoreQueryPrefix: true })
    const id = 'id' in search ? search.id : null
    if (!id) {
      this.$router.push('/email')
      return false
    }
    this.fetchId = parseInt(id)
  },
  methods: {
    async send () {
      const { gongid, mailTitle, senderMail, senderPwd, target } = this
      if (!gongid && target == '1') {
        this.$notify.error({
          title: '错误',
          message: '请输入工号'
        })
        return false
      }
      if (!mailTitle) {
        this.$notify.error({
          title: '错误',
          message: '请输入邮件标题'
        })
        return false
      }
      if (!senderMail) {
        this.$notify.error({
          title: '错误',
          message: '请输入发件人邮箱'
        })
        return false
      }
      if (!senderPwd) {
        this.$notify.error({
          title: '错误',
          message: '请输入密码'
        })
        return false
      }
      // 测试发送的接口调用
      await this.$http.post('/emailj/realsend', {
        fileid: this.fetchId,
        id: target == '1' ? Number(gongid) : Number(target),
        from: senderMail,
        pass: senderPwd,
        subject: mailTitle
      })
    },
    beforeFetch (params) {
      params.mode = this.activeBtn
    },
    sort (activeBtn) {
      this.activeBtn = activeBtn
      this.$refs.table.reload()
    }
  }
}
</script>
<style lang="scss" scoped>
.mail-send {
  padding: 20px 20px 0;
  background: #fff;

  .mail-input {
    width: 200px;
    margin-right: 10px;
  }
  button {
    height: 32px;
  }
}
</style>
